// @flow

import React from 'react';
import styled from 'styled-components';
import { flex, topMargin, Color } from 'styles';
import { BlockyText } from 'components/Content';

const Wrapper = styled.div`
  ${flex()};
  ${({ marginTop }) => topMargin(...marginTop)};
  flex-direction: column;

  > div {
    padding: 36px;
    background: ${Color.WHITE};
    margin-bottom: 16px;
    box-shadow: 0 3px 16px rgba(0, 0, 0, 0.02);
    max-width: 688px;
  }
`;

type Props = {
  marginTop?: number[],
  content: any[],
};

const BlockyCardList = ({ marginTop = [0, 0, 0], content, ...rest }: Props) => (
  <Wrapper {...rest} marginTop={marginTop} role="list">
    {content.map((itemContent, index) => (
      <BlockyText role="listitem" key={`BlockyCardList-${index}`} {...itemContent} />
    ))}
  </Wrapper>
);

BlockyCardList.contentType = 'BlockyCardList';

export default BlockyCardList;
